import React, {useEffect, useState} from "react";
import ChervonDown from "../icons/ChervonDown";
import Search from "../icons/Search";
import Reset from "../icons/Reset";
import ArrowRight from "../icons/ArrowRight";
import Play from "../icons/Play";
import GLightbox from 'glightbox';

import accordion from "../../components/accordion";

const FAQsApp = (props) => {

    const {
        items,
        sections,
        categories,
    } = props.data;

    const [results, setResults] = useState([]);
    const [selectedS, setSelectedS] = useState(null);
    const [selectedC, setSelectedC] = useState([]);
    const [keywords, setKeywords] = useState('');
    const [video, setVideo] = useState(false);
    const [opened, setOpened] = useState(opened);


    useEffect(() => {
        setResults(items);
    }, []);


    useEffect(() => {

        const r = [];
        items.map((i) => {
            let matched = true;
            if (selectedS && i.sections.indexOf(selectedS.id) == -1) {
                matched = false;
            }
            if (matched && selectedC && selectedC.length) {
                const intercept = i.categories.filter((c) => {
                    return selectedC.indexOf(c) >= 0
                });
                if (intercept.length === 0) {
                    matched = false;
                }
            }
            if (matched && video) {
                if (!i.video) {
                    matched = false;
                }
            }
            if (matched && keywords) {
                if (i.title.toLowerCase().indexOf(keywords.toLowerCase()) == -1) {
                    matched = false;
                }
            }


            if (matched) {
                r.push(i);
            }
        });
        setResults(r);
        window.setTimeout(() => {
            accordion();

            GLightbox({
                selector: '[data-media]',
                videosWidth: 1130
            });
        }, 100)

    }, [selectedS, selectedC, keywords, video]);

    const addRemoveFilter = (category) => {
        const list = [...selectedC];
        if (selectedC.indexOf(category.id) >= 0) {
            list.splice(selectedC.indexOf(category.id), 1);
        } else {
            list.push(category.id);
        }
        setSelectedC(list);
        setOpened(false);
    }

    const resetFilters = () => {
        setSelectedS(null);
        setSelectedC([]);
        setKeywords('');
    }


    return <div className="faqs__app">
        <div className="faqs__app__container">
            <div className="faqs__app__categories">
                <h3>Categories</h3>
                <ul>
                    <li
                        onClick={() => {
                            setSelectedC([]);
                            setSelectedS(null);
                            setOpened(!opened)
                        }}
                        className={!selectedS ? 'active' : ''}>
                        All
                        <span>
                            <ChervonDown />
                        </span>
                    </li>
                    {sections.map((section) => {

                        const cls = [];
                        if (opened) {
                            cls.push('opened');
                        }
                        if (selectedS && section.id === selectedS.id) {
                            cls.push('active');
                        }

                        return <li
                            key={section.id}
                            onClick={() => {
                                setSelectedC([]);
                                setSelectedS(section);
                                setOpened(false)
                            }}
                            className={cls.join(' ')}>
                            {section.title}
                        </li>
                    })}
                </ul>
            </div>
            <div className="faqs__app__results">
                <div className="faqs__app__search">
                    <Search />
                    <input
                        type="text"
                        placeholder="Search"
                        value={keywords}
                        onChange={(e) => {
                            setKeywords(e.target.value);
                        }}
                    />
                </div>
                <div className="faqs__app__filters">
                    <h4>Filters</h4>
                    <button
                        className="btn btn--grey--solid"
                        onClick={resetFilters}
                    >
                        Reset <Reset />
                    </button>
                    <ul>
                        {categories.map((category) => {
                            if (!selectedS || selectedS.categories.indexOf(category.id) >= 0) {
                                const className = (selectedC.indexOf(category.id) >= 0)
                                    ? 'btn btn--primary--hollow active'
                                    : 'btn btn--primary--hollow';
                                return <li
                                    key={category.id}>
                                    <button
                                        className={className}
                                        onClick={() => {
                                            addRemoveFilter(category);
                                        }}>
                                        {category.title}
                                    </button>
                                </li>
                            }
                            return null;
                        })}
                        <li>
                            <button
                                className={video ? 'btn btn--primary--hollow active' : 'btn btn--primary--hollow'}
                                onClick={() => {
                                    setVideo(!video)
                                }}>Video</button>
                        </li>
                    </ul>
                </div>
                <div className="faqs__app__desc">
                    <p>Use the filters below to get to what you want quicker</p>
                </div>

                <div className="faqs__app__items" data-accordion={1}>
                    {results.map((result) => {
                        // const result = results[key];
                        // console.log(key)
                        return <div className="faq" key={result.id} data-acc-item={1} data-faq-item={1}>
                            <div className="faq__inner">
                                <div className="faq__title" data-accordion-title={1}>
                                    <div className="faq__title-body">
                                        <div className="faq__chevron">
                                            <ChervonDown />
                                        </div>
                                        <h4>{result.title}</h4>
                                    </div>
                                </div>
                                <div className="faq__content" data-accordion-content={1}>
                                    <div className="faq__content__inner">
                                        {!!result.image && <>
                                            {!!result.video && <a
                                                href={result.video}
                                                data-media={1}
                                                className="faq__image"
                                                style={{backgroundImage: `url(${result.image})`}}>
                                                <Play />
                                            </a>}
                                            {!result.video && <div
                                                data-media={1}
                                                className="faq__image"
                                                style={{backgroundImage: `url(${result.image})`}} />}
                                        </>}

                                        {!!result.html && <div
                                            className="faq__body"
                                            dangerouslySetInnerHTML={{__html: result.html}}
                                        />}

                                        {(!!result.action && result.action.link) && <div className="faq__action">
                                            <a href={result.action.link} target={result.action.target}
                                               className="btn btn--txt btn--white--txt">
                                                {result.action.title}
                                                <ArrowRight />
                                            </a>
                                        </div>}

                                    </div>
                                </div>
                            </div>
                        </div>
                    })}


                </div>

            </div>
        </div>
    </div>

}

export default FAQsApp;
